import PropTypes from 'prop-types';

import { useDesignContext } from '@febos-io/design/src/providers';

import { useCompanyPatientByIdEffect, useTranslation } from '../hooks';

export function PatientIdentification(
  {
    companyId,
    patientId,
  }
) {
  const { t, } = useTranslation();
  const { Loader, } = useDesignContext();
  const {
    loading,
    element,
  } = useCompanyPatientByIdEffect(companyId, patientId);
  return (
    <div className="d-flex flex-column justify-content-between flex-grow-1">
      <div className="row gx-2">
        {loading ? (
          <Loader />
        ) : (
          <>
            <p>
              {t('Identification Number')}
              :
              {element.identificationNumber}
            </p>
            <p>
              {t('Name')}
              :
              {element.name}
            </p>
            <p>
              {t('Last Name')}
              :
              {element.lastName}
            </p>
            <p>
              {t('Birth Date')}
              :
              {element.birthDate}
            </p>
          </>
        )}
      </div>
    </div>
  );
}

export default PatientIdentification;

PatientIdentification.propTypes = {
  companyId: PropTypes.elementType.isRequired,
  patientId: PropTypes.elementType.isRequired,
};
